export enum DisplayState {
  loading,
  error,
  unsupportedFormat,
  showPdf,
}
